import React, { Fragment } from 'react';
import EmployeesList from '../../../users/EmployeesList';
import { observer } from 'mobx-react';
import EmployeesListsContainer from '../../../users/assessment-users/EmployeesListsContainer';
import { useAssessmentType } from '../../useAssessmentType';
function Employees({ companyId, assessmentId, showLists = true }) {

    const { assessmentStore,
        assessmentUsersStoresFactory
    } = useAssessmentType()

    const { employeesOverviewStore: assessmentUsersStore } =
        assessmentUsersStoresFactory;
    return (
        <Fragment>
            {showLists && (
                <EmployeesListsContainer
                    companyId={companyId}
                    assessmentId={assessmentId}
                />
            )}
            <EmployeesList
                companyId={companyId}
                assessmentId={assessmentId}
                assessmentUsersStore={assessmentUsersStore}
                product={assessmentStore.editingAssessment}
                canRemind={assessmentStore.editingAssessment.canRemind}
            />
        </Fragment>
    );
}

export default observer(Employees);
